// Custom icon used as image voting arrangement "vertical" (DEV-1767)
const faEllipsisVSquare = {
  prefix: "fat",
  iconName: "ellipsis-v-square",
  icon: [
    160,
    512,
    [],
    null,
    "M96 32c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h64zM96 192c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h64zM96 352c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32h-64c-17.7 0-32-14.3-32-32v-64c0-17.7 14.3-32 32-32h64z",
  ],
}

const faAverage = {
  prefix: "fat",
  iconName: "average",
  icon: [
    395,
    385,
    [],
    null,
    "M384.29,332.37,333.63,383c-4.93,4.92-7.75,4.92-12.67,0-1.21-1.21-2.43-2.41-3.63-3.64-4-4.12-4-7.42.22-11.43q14.73-14.1,29.52-28.15a24.38,24.38,0,0,1,2.71-2l-.71-.92H71.86a17.61,17.61,0,0,1-6.11-.76,4.43,4.43,0,0,1-3-3.14,1.18,1.18,0,0,1-.07-.2c0-.13-.08-.27-.11-.41a22,22,0,0,1-.5-5.4c0-.41,0-.78,0-1.17s0-.74,0-1.14V51.88c-1.4-.18-1.78,1-2.41,1.64Q45.57,68.24,31.5,83c-4.6,4.82-7.66,4.87-12.39.17C17.49,81.57,15.8,80,14.3,78.29c-2.56-2.93-2.55-5.89-.13-9a27.29,27.29,0,0,1,1.88-2L66.4,16.86c5.1-5.11,8.28-5.14,13.3-.12Q105,42.06,130.36,67.39c4.92,4.93,4.92,7.76,0,12.67-1.21,1.21-2.41,2.44-3.64,3.63-4.12,4-7.42,4-11.43-.22Q101.2,68.76,87.16,54a25.47,25.47,0,0,1-2-2.72l-.92.71V314.76H349.14c.19-1.4-1-1.78-1.64-2.41Q332.79,298.24,318,284.17c-4.82-4.6-4.86-7.66-.17-12.39,1.62-1.62,3.17-3.31,4.89-4.81,2.94-2.55,5.9-2.55,9-.12a25,25,0,0,1,2,1.87l50.48,50.35C389.27,324.17,389.3,327.35,384.29,332.37ZM181.06,140c11.08,17.32,23.24,33.92,34.92,50.83,3.21,4.65,8.08,4.65,11.29,0,11.68-16.92,23.86-33.49,34.9-50.84,4.47-7,7.67-14.51,8.4-23.09a49.73,49.73,0,0,0-29.86-50c-32.19-13.6-68.23,10.34-68.24,47.9C172,122.47,175.66,131.52,181.06,140Zm61-27.73a20.47,20.47,0,1,1-20.55-20.46A20.75,20.75,0,0,1,242.09,112.22Z",
  ],
}
const faIndividual = {
  prefix: "fat",
  iconName: "individual",
  icon: [
    395,
    385,
    [],
    null,
    "M384.29,332.37,333.63,383c-4.93,4.92-7.75,4.92-12.67,0-1.21-1.21-2.43-2.41-3.63-3.64-4-4.12-4-7.42.22-11.43q14.73-14.1,29.52-28.15a24.38,24.38,0,0,1,2.71-2l-.71-.92H71.86a17.61,17.61,0,0,1-6.11-.76,4.43,4.43,0,0,1-3-3.14,1.18,1.18,0,0,1-.07-.2c0-.13-.08-.27-.11-.41a22,22,0,0,1-.5-5.4c0-.41,0-.78,0-1.17s0-.74,0-1.14V51.88c-1.4-.18-1.78,1-2.41,1.64Q45.57,68.24,31.5,83c-4.6,4.82-7.66,4.87-12.39.17C17.49,81.57,15.8,80,14.3,78.29c-2.56-2.93-2.55-5.89-.13-9a27.29,27.29,0,0,1,1.88-2L66.4,16.86c5.1-5.11,8.28-5.14,13.3-.12Q105,42.06,130.36,67.39c4.92,4.93,4.92,7.76,0,12.67-1.21,1.21-2.41,2.44-3.64,3.63-4.12,4-7.42,4-11.43-.22Q101.2,68.76,87.16,54a25.47,25.47,0,0,1-2-2.72l-.92.71V314.76H349.14c.19-1.4-1-1.78-1.64-2.41Q332.79,298.24,318,284.17c-4.82-4.6-4.86-7.66-.17-12.39,1.62-1.62,3.17-3.31,4.89-4.81,2.94-2.55,5.9-2.55,9-.12a25,25,0,0,1,2,1.87l50.48,50.35C389.27,324.17,389.3,327.35,384.29,332.37ZM128.5,161A16.5,16.5,0,1,0,145,177.5,16.5,16.5,0,0,0,128.5,161Zm52,85A16.5,16.5,0,1,0,197,262.5,16.5,16.5,0,0,0,180.5,246Zm136-136A16.5,16.5,0,1,0,333,126.5,16.5,16.5,0,0,0,316.5,110ZM205,221.5A16.5,16.5,0,1,0,221.5,205,16.5,16.5,0,0,0,205,221.5Zm125-44A16.5,16.5,0,1,0,346.5,161,16.5,16.5,0,0,0,330,177.5Z",
  ],
}
const faAverageIndividual = {
  prefix: "fat",
  iconName: "average-individual",
  icon: [
    395,
    385,
    [],
    null,
    "M384.29,332.37,333.63,383c-4.93,4.92-7.75,4.92-12.67,0-1.21-1.21-2.43-2.41-3.63-3.64-4-4.12-4-7.42.22-11.43q14.73-14.1,29.52-28.15a24.38,24.38,0,0,1,2.71-2l-.71-.92H71.86a17.61,17.61,0,0,1-6.11-.76,4.43,4.43,0,0,1-3-3.14,1.18,1.18,0,0,1-.07-.2c0-.13-.08-.27-.11-.41a22,22,0,0,1-.5-5.4c0-.41,0-.78,0-1.17s0-.74,0-1.14V51.88c-1.4-.18-1.78,1-2.41,1.64Q45.57,68.24,31.5,83c-4.6,4.82-7.66,4.87-12.39.17C17.49,81.57,15.8,80,14.3,78.29c-2.56-2.93-2.55-5.89-.13-9a27.29,27.29,0,0,1,1.88-2L66.4,16.86c5.1-5.11,8.28-5.14,13.3-.12Q105,42.06,130.36,67.39c4.92,4.93,4.92,7.76,0,12.67-1.21,1.21-2.41,2.44-3.64,3.63-4.12,4-7.42,4-11.43-.22Q101.2,68.76,87.16,54a25.47,25.47,0,0,1-2-2.72l-.92.71V314.76H349.14c.19-1.4-1-1.78-1.64-2.41Q332.79,298.24,318,284.17c-4.82-4.6-4.86-7.66-.17-12.39,1.62-1.62,3.17-3.31,4.89-4.81,2.94-2.55,5.9-2.55,9-.12a25,25,0,0,1,2,1.87l50.48,50.35C389.27,324.17,389.3,327.35,384.29,332.37ZM128.5,161A16.5,16.5,0,1,0,145,177.5,16.5,16.5,0,0,0,128.5,161Zm52,85A16.5,16.5,0,1,0,197,262.5,16.5,16.5,0,0,0,180.5,246Zm136-136A16.5,16.5,0,1,0,333,126.5,16.5,16.5,0,0,0,316.5,110ZM181.06,140c11.08,17.32,23.24,33.92,34.92,50.83,3.21,4.65,8.08,4.65,11.29,0,11.68-16.92,23.86-33.49,34.9-50.84,4.47-7,7.67-14.51,8.4-23.09a49.73,49.73,0,0,0-29.86-50c-32.19-13.6-68.23,10.34-68.24,47.9C172,122.47,175.66,131.52,181.06,140Zm61-27.73a20.47,20.47,0,1,1-20.55-20.46A20.75,20.75,0,0,1,242.09,112.22ZM205,221.5A16.5,16.5,0,1,0,221.5,205,16.5,16.5,0,0,0,205,221.5Zm125-44A16.5,16.5,0,1,0,346.5,161,16.5,16.5,0,0,0,330,177.5Z",
  ],
}

const faSurvey = {
  prefix: "fat",
  iconName: "survey",
  icon: [
    79.66,
    77,
    [],
    null,
    "M5.8,52.6a12.45,12.45,0,0,1,.25-4.43A10.88,10.88,0,0,1,7.42,45a11.51,11.51,0,0,1,2-2.31c.75-.64,1.46-1.27,2.1-1.87A10.35,10.35,0,0,0,13.15,39a4.14,4.14,0,0,0,.65-2.33,3.94,3.94,0,0,0-1-2.8A4.65,4.65,0,0,0,9.35,32.8a8.71,8.71,0,0,0-1.7.18,11,11,0,0,0-1.8.5,12.08,12.08,0,0,0-1.72.75,12.58,12.58,0,0,0-1.48.87L.15,30.3a18.34,18.34,0,0,1,4.37-2.15,18.45,18.45,0,0,1,6-.85,10.92,10.92,0,0,1,7.35,2.28A7.63,7.63,0,0,1,20.5,35.7a11.55,11.55,0,0,1-.67,4.22,10.33,10.33,0,0,1-1.68,2.86A13.86,13.86,0,0,1,16,44.85a18.64,18.64,0,0,0-2.2,1.93,9.81,9.81,0,0,0-1.7,2.37,7.43,7.43,0,0,0-.7,3.45Zm-1,7.1a3.64,3.64,0,0,1,1.1-2.78,4.09,4.09,0,0,1,2.9-1,4.23,4.23,0,0,1,3,1,3.64,3.64,0,0,1,1.1,2.78,3.7,3.7,0,0,1-1.1,2.8,4.15,4.15,0,0,1-3,1,4,4,0,0,1-2.9-1A3.7,3.7,0,0,1,4.8,59.7ZM25.19,50.82a24,24,0,0,1,.49-8.58,21,21,0,0,1,2.66-6.11,22.1,22.1,0,0,1,3.88-4.46C33.68,30.41,35,29.19,36.3,28a20.22,20.22,0,0,0,3.15-3.64,7.93,7.93,0,0,0,1.26-4.51,7.67,7.67,0,0,0-1.89-5.43q-1.89-2-6.74-2a17.78,17.78,0,0,0-3.3.34,23.92,23.92,0,0,0-3.49,1,28.72,28.72,0,0,0-3.35,1.46,26.69,26.69,0,0,0-2.86,1.69L14.23,7.56a35.34,35.34,0,0,1,8.49-4.17A35.83,35.83,0,0,1,34.31,1.74q9.12,0,14.26,4.42A14.84,14.84,0,0,1,53.71,18a22.09,22.09,0,0,1-1.31,8.19,19.93,19.93,0,0,1-3.25,5.53,26.18,26.18,0,0,1-4.27,4,36.69,36.69,0,0,0-4.26,3.73,18.91,18.91,0,0,0-3.3,4.61A14.45,14.45,0,0,0,36,50.82ZM23.25,64.6a7,7,0,0,1,2.14-5.39,7.92,7.92,0,0,1,5.62-2,8.21,8.21,0,0,1,5.82,2A7,7,0,0,1,39,64.6,7.18,7.18,0,0,1,36.83,70a8.07,8.07,0,0,1-5.82,2,7.78,7.78,0,0,1-5.62-2A7.14,7.14,0,0,1,23.25,64.6ZM60.11,64.06a16.64,16.64,0,0,1,.34-5.93,14.56,14.56,0,0,1,1.84-4.22A14.81,14.81,0,0,1,65,50.83c1-.87,1.94-1.71,2.81-2.51A14.3,14.3,0,0,0,70,45.81a5.49,5.49,0,0,0,.87-3.12,5.3,5.3,0,0,0-1.3-3.75q-1.32-1.41-4.66-1.41a11.64,11.64,0,0,0-2.28.24,15.49,15.49,0,0,0-2.41.67,19.15,19.15,0,0,0-2.31,1,17.87,17.87,0,0,0-2,1.17l-3.35-6.43A24.42,24.42,0,0,1,58.4,31.3a24.77,24.77,0,0,1,8-1.14q6.3,0,9.85,3.05a10.26,10.26,0,0,1,3.55,8.21,15.33,15.33,0,0,1-.9,5.66,14,14,0,0,1-2.25,3.82,17.6,17.6,0,0,1-3,2.78,25.35,25.35,0,0,0-2.95,2.58,13.18,13.18,0,0,0-2.27,3.18,10,10,0,0,0-.94,4.62Zm-1.34,9.52a4.81,4.81,0,0,1,1.48-3.72,5.43,5.43,0,0,1,3.88-1.37,5.63,5.63,0,0,1,4,1.37,4.85,4.85,0,0,1,1.48,3.72,5,5,0,0,1-1.48,3.75,5.57,5.57,0,0,1-4,1.41,5.37,5.37,0,0,1-3.88-1.41A4.93,4.93,0,0,1,58.77,73.58Z",
  ],
}

import { library } from "@fortawesome/fontawesome-svg-core"
import {
  faAddressBook,
  faAlignCenter,
  faAlignJustify,
  faAlignLeft,
  faAlignRight,
  faArrowCircleUp,
  faAward,
  faBan,
  faBars,
  faBold,
  faBoxes,
  faBullhorn,
  faCalendarAlt,
  faCaretDown,
  faCaretRight,
  faCaretUp,
  faChartBar,
  faChartColumn,
  faChartLine,
  faChartPie,
  faCheck,
  faCheckCircle,
  faCheckSquare as fasCheckSquare,
  faChevronCircleDown,
  faChevronDown,
  faChevronLeft,
  faCircle as fasCircle,
  faCircleArrowRight,
  faCircleMinus,
  faCircleNotch,
  faClock,
  faClone,
  faCloud,
  faCode,
  faCog,
  faCogs,
  faCommentDots,
  faComments,
  faCompress,
  faCopy,
  faDoorClosed,
  faDoorOpen,
  faDownload,
  faEdit,
  faEllipsisV,
  faEraser,
  faExchangeAlt,
  faExclamationCircle,
  faExclamationTriangle,
  faExpand,
  faExternalLinkAlt,
  faEye,
  faEyeSlash,
  faFile,
  faFileAlt,
  faFileContract,
  faFileCsv,
  faFileExcel,
  faFileExport,
  faFilter,
  faFire,
  faGamepad,
  faGhost,
  faGripHorizontal,
  faGripVertical,
  faHourglassStart,
  faHourglassHalf,
  faHourglassEnd,
  faImage as fasImage,
  faImages,
  faIndent,
  faInfoCircle,
  faItalic,
  faKey,
  faLevelUpAlt,
  faLink,
  faList,
  faListOl,
  faListUl,
  faLock as fasLock,
  faLongArrowAltRight,
  faLongArrowAltUp,
  faMinus,
  faOutdent,
  faPalette,
  faPaperclip,
  faPaste,
  faPeopleGroup,
  faPersonBooth,
  faPlayCircle,
  faPlus,
  faPlusCircle,
  faPoll,
  faQrcode,
  faRedo,
  faSearch,
  faSearchMinus,
  faSearchPlus,
  faShare,
  faShareAlt,
  faSignature,
  faSignInAlt,
  faSignOutAlt,
  faSlidersH,
  faSmile,
  faSpinner,
  faSquare as fasSquare,
  faStar as fasStar,
  faStopCircle,
  faStrikethrough,
  faSuitcase,
  faSyncAlt,
  faTachometerAlt,
  faTag,
  faThList,
  faThermometerThreeQuarters,
  faTimes,
  faTimesCircle,
  faToggleOn,
  faTools,
  faTrash,
  faTrophy,
  faTv,
  faUnderline,
  faUndo,
  faUndoAlt,
  faUniversalAccess,
  faUpload,
  faUser,
  faUserCheck,
  faUserCircle,
  faUserCog as fasUserCog,
  faUsersRectangle,
  faUserSecret,
  faUsers as fasUsers,
  faUsersBetweenLines,
  faUsersCog,
  faUserClock,
  faUserPlus,
  faVideo,
  faVoteYea,
  faIdBadge,
} from "@fortawesome/free-solid-svg-icons"

import {
  faCalendarCheck,
  faCaretSquareRight,
  faCheckSquare as farCheckSquare,
  faCircle as farCircle,
  faEnvelope,
  faHeart,
  faImage as farImage,
  faQuestionCircle,
  faSquare as farSquare,
  faStar as farStar,
} from "@fortawesome/free-regular-svg-icons"

import {
  faAnalytics,
  faBoltAuto,
  faChartScatter,
  faChartUser,
  faChevronsDown,
  faChevronsUp,
  faClipboardCheck as faClipboardCheckSolid,
  faFileCertificate,
  faFilePng,
  faFileSvg,
  faFirstAid,
  faPencil,
  faPersonSimple,
  faRectangleLandscape,
  faSlidersUp,
  faTrafficCone,
  faUserKey,
  faUserCirclePlus,
} from "@fortawesome/pro-solid-svg-icons"

import {
  faClipboard,
  faClipboardCheck,
  faClipboardQuestion,
  faHandshake,
  faHandshakeSlash,
  faInfinity,
  faLock as farLock,
  faUserCog as farUserCog,
  faUsers as farUsers,
} from "@fortawesome/pro-regular-svg-icons"

import { faCheckCircle as fadCheckCircle, faTimesCircle as fadTimesCircle } from "@fortawesome/pro-duotone-svg-icons"

library.add(
  faAnalytics,
  faAddressBook,
  faAlignCenter,
  faAlignJustify,
  faAlignLeft,
  faAlignRight,
  faArrowCircleUp,
  faAward,
  faBan,
  faBars,
  faBold,
  faBoltAuto,
  faBoxes,
  faBullhorn,
  faCalendarAlt,
  faCalendarCheck,
  faCaretDown,
  faCaretRight,
  faCaretSquareRight,
  faCaretUp,
  faChartBar,
  faChartColumn,
  faChartPie,
  faChartLine,
  faChartScatter,
  faChartUser,
  faCheck,
  faCheckCircle,
  fadCheckCircle,
  farCheckSquare,
  fasCheckSquare,
  faChevronCircleDown,
  faChevronDown,
  faChevronLeft,
  faChevronsDown,
  faChevronsUp,
  farCircle,
  fasCircle,
  faCircleArrowRight,
  faCircleMinus,
  faCircleNotch,
  faClipboard,
  faClipboardCheck,
  faClipboardCheckSolid,
  faClipboardQuestion,
  faClock,
  faClone,
  faCloud,
  faCode,
  faCog,
  faCogs,
  faCommentDots,
  faComments,
  faCompress,
  faCopy,
  faDoorClosed,
  faDoorOpen,
  faDownload,
  faEdit,
  faEllipsisV,
  faEnvelope,
  faEraser,
  faExchangeAlt,
  faExclamationCircle,
  faExclamationTriangle,
  faExpand,
  faExternalLinkAlt,
  faEye,
  faEyeSlash,
  faFile,
  faFileAlt,
  faFileCertificate,
  faFileContract,
  faFileCsv,
  faFileExcel,
  faFileExport,
  faFilePng,
  faFileSvg,
  faFilter,
  faFire,
  faFirstAid,
  faGamepad,
  faGhost,
  faGripHorizontal,
  faGripVertical,
  faHeart,
  faGripVertical,
  faHandshake,
  faHandshakeSlash,
  faHourglassStart,
  faHourglassHalf,
  faHourglassEnd,
  faIdBadge,
  farImage,
  fasImage,
  faImages,
  faIndent,
  faInfinity,
  faInfoCircle,
  faItalic,
  faKey,
  faLevelUpAlt,
  faLink,
  faList,
  faListOl,
  faListUl,
  farLock,
  fasLock,
  faLongArrowAltRight,
  faLongArrowAltUp,
  faMinus,
  faOutdent,
  faPalette,
  faPaperclip,
  faPaste,
  faPencil,
  faPeopleGroup,
  faPersonBooth,
  faPersonSimple,
  faPlayCircle,
  faPlus,
  faPlusCircle,
  faPoll,
  faQuestionCircle,
  faQrcode,
  faRectangleLandscape,
  faRedo,
  faSearch,
  faSearchMinus,
  faSearchPlus,
  faShare,
  faShareAlt,
  faSignature,
  faSignInAlt,
  faSignOutAlt,
  faSlidersH,
  faSlidersUp,
  faSmile,
  faSpinner,
  farSquare,
  fasSquare,
  fasStar,
  farStar,
  faStopCircle,
  faStrikethrough,
  faSuitcase,
  faSyncAlt,
  faTachometerAlt,
  faTag,
  faThermometerThreeQuarters,
  faThList,
  faTimes,
  faTimesCircle,
  fadTimesCircle,
  faToggleOn,
  faTools,
  faTrafficCone,
  faTrash,
  faTrophy,
  faTv,
  faUnderline,
  faUndo,
  faUndoAlt,
  faUniversalAccess,
  faUpload,
  faUser,
  faUserCheck,
  faUserCircle,
  faUserCirclePlus,
  farUserCog,
  fasUserCog,
  faUserClock,
  faUserKey,
  faUserSecret,
  farUsers,
  fasUsers,
  faUsersRectangle,
  faUsersBetweenLines,
  faUsersCog,
  faUserPlus,
  faVideo,
  faVoteYea,
  faEllipsisVSquare,
  faAverage,
  faIndividual,
  faAverageIndividual,
  faSurvey
)
